
import analytics from '@/mixins.js/analytics'

export default {
  mixins: [analytics],
  props: {
    diagram: { type: Object },
    listName: { type: String },
    listPosition: { type: Number }
  }
}
